/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence } from './submit-completed-workflow-of-draft-payment-requests-request-evidence';
// May contain unused imports in some cases
// @ts-ignore
import { SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier } from './submit-completed-workflow-of-draft-payment-requests-request-supplier';

/**
 * 
 * @export
 * @interface SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
 */
export interface SubmitCompletedWorkflowOfDraftPaymentRequestsRequest {
    /**
     * 
     * @type {SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'supplier': SubmitCompletedWorkflowOfDraftPaymentRequestsRequestSupplier;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'transferFeeResponsibility': SubmitCompletedWorkflowOfDraftPaymentRequestsRequestTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'withholdingCalculatingMethod': SubmitCompletedWorkflowOfDraftPaymentRequestsRequestWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'withholdingAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'memo': string | null;
    /**
     * Please set the ID of the evidence from which the payment request. If you are treating the new file as an invoice, be sure to set `evidence`.
     * @type {string}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'invoiceEvidenceId': string | null;
    /**
     * 
     * @type {SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence}
     * @memberof SubmitCompletedWorkflowOfDraftPaymentRequestsRequest
     */
    'evidence': SubmitCompletedWorkflowOfDraftPaymentRequestsRequestEvidence | null;
}

export const SubmitCompletedWorkflowOfDraftPaymentRequestsRequestTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type SubmitCompletedWorkflowOfDraftPaymentRequestsRequestTransferFeeResponsibilityEnum = typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestTransferFeeResponsibilityEnum[keyof typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestTransferFeeResponsibilityEnum];
export const SubmitCompletedWorkflowOfDraftPaymentRequestsRequestWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type SubmitCompletedWorkflowOfDraftPaymentRequestsRequestWithholdingCalculatingMethodEnum = typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestWithholdingCalculatingMethodEnum[keyof typeof SubmitCompletedWorkflowOfDraftPaymentRequestsRequestWithholdingCalculatingMethodEnum];


